<template>
  <v-dialog
    v-model="ativarDialog"
    width="50em"
    lazy
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    @keydown.esc="fecharDialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
          <v-btn
            icon
            color="info"
            v-bind="{ ...attrs, ...attrsTooltip }"
            v-on="{ ...on, ...onTooltip }"
          >
            <v-icon>swap_horiz</v-icon>
          </v-btn>
        </template>
        <h3>Transferir dados de Posto</h3>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title class="justify-center">
        <v-btn
          icon
          color="info"
          @click="step = 1"
          v-if="step > 1"
          style="position: absolute; left: 1.5em;"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <h1>{{ titulo }}</h1>
      </v-card-title>
      <v-divider></v-divider>

      <v-alert
        :value="alerta.ativo"
        :type="alerta.tipo"
        transition="scale-transition"
        class="ma-0"
        style="border-radius: 0;"
      >
        {{ alerta.texto }}
      </v-alert>

      <v-card-text>
        <v-stepper v-model="step" style="box-shadow: none;" class="ma-0 pa-0">
          <v-stepper-items>
            <v-stepper-content step="1" class="ma-0 pa-0">
              <v-form lazy-validation v-model="valido" ref="form">
                <v-text-field
                  label="CNPJ de Origem"
                  outline
                  v-model.lazy="transferenciaData.cnpj_origem"
                  :rules="[
                    v => !!v || 'O CNPJ de origem é obrigatório',
                    v => v && v.length === 14 || 'O CNPJ deve conter 14 dígitos'
                  ]"
                  required
                  prepend-icon="store"
                  mask="##.###.###/####-##"
                ></v-text-field>
                <v-card v-if="posto_origin" class="ma-4">
                  <v-layout row justify-space-between class="ma-2">
                    <v-flex xs3>
                      <v-img v-if="posto_origin.url_logo" :src="posto_origin.url_logo" max-width="100px" max-height="100px"></v-img>
                      <v-icon v-else class="ma-2" size="80">local_gas_station</v-icon>
                    </v-flex>
                    <v-flex xs9>
                      <h3>{{ posto_origin.nome_fantasia }}</h3>
                      <p>{{ posto_origin.razao_social }}</p>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-text-field
                  label="CNPJ de Destino"
                  outline
                  v-model.lazy="transferenciaData.cnpj_destino"
                  required
                  prepend-icon="place"
                  mask="##.###.###/####-##"
                  :rules="[
                    v => !!v || 'O CNPJ de destino é obrigatório',
                    v => v && v.length === 14 || 'O CNPJ deve ter 14 dígitos'
                  ]"
                ></v-text-field>
                <v-card v-if="posto_destino" class="ma-4">
                  <v-layout row justify-space-between class="ma-2">
                    <v-flex xs3>
                      <v-img v-if="posto_destino.url_logo" :src="posto_destino.url_logo" max-width="100px" max-height="100px"></v-img>
                      <v-icon v-else size="80" class="ma-2">local_gas_station</v-icon>
                    </v-flex>
                    <v-flex xs9>
                      <h3>{{ posto_destino.nome_fantasia }}</h3>
                      <p>{{ posto_destino.razao_social }}</p>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2" class="justify-center ma-0 pa-0 text-xs-center">
              <h2 class="mb-3">
                Você tem certeza que deseja transferir todos os dados do posto
                <b v-if="posto_origin">
                  {{posto_origin.nome_fantasia}} - {{ transferenciaData.cnpj_origem }}
                </b> para o posto
                <b>
                  <span v-if="posto_destino">
                    {{posto_destino.nome_fantasia}} -
                  </span>
                  {{ transferenciaData.cnpj_destino }}
                </b>?
              </h2>
              <p class="error--text">
                <v-icon color="error" class="mr-1">warning</v-icon>
                Esta ação não pode ser desfeita.
              </p>
              <p v-if="!posto_destino && transferenciaData.cnpj_destino && transferenciaData.cnpj_destino.length === 14">
                O posto de destino será criado com os mesmos dados do posto de origem, caso não seja encontrado.
              </p>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-card-actions class="justify-space-around">
        <template v-if="step === 1">
          <v-btn large @click="fecharDialog" flat>Cancelar</v-btn>
          <v-btn
            large
            color="info"
            :disabled="!valido || loading || !posto_origin"
            :loading="loading"
            @click="prosseguirParaConfirmacao"
            flat
          >
            Transferir
            <v-icon class="ml-2">arrow_forward</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn large @click="step = 1" flat :disabled="loading">Voltar</v-btn>
          <v-btn
            large
            color="success"
            :loading="loading"
            :disabled="loading"
            @click="executarTransferencia"
            flat
          >
            <v-icon class="mr-2">check_circle</v-icon>
            Confirmar e Transferir
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    ativarDialog: false,
    step: 1,
    valido: false,
    alerta: {
      ativo: false,
      tipo: 'error',
      texto: ''
    },
    transferenciaData: {
      cnpj_origem: null,
      cnpj_destino: null,
      criar_destino_se_nao_existir: false
    },
    posto_origin: null,
    posto_destino: null
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    titulo () {
      if (this.step === 1) return 'TRANSFERIR DADOS DE POSTO'
      else return 'CONFIRMAR TRANSFERÊNCIA'
    }
  },
  watch: {
    ativarDialog (val) {
      if (!val) {
        this.resetarComponente()
      }
    },
    'transferenciaData.cnpj_origem' (val) {
      if (val && val.length === 14) {
        this.pegarPostoPorCNPJ(val)
      } else {
        this.posto_origin = null
      }
    },
    'transferenciaData.cnpj_destino' (val) {
      if (val && val.length === 14) {
        this.pegarPostoPorCNPJ(val)
      } else {
        this.posto_destino = null
      }
    }
  },
  methods: {
    fecharDialog () {
      this.ativarDialog = false
    },
    pegarPostoPorCNPJ (cnpj) {
      this.$store.dispatch('pegarPostoPorCNPJ', cnpj).then((json) => {
        if (cnpj === this.transferenciaData.cnpj_origem) {
          console.log('posto origem')
          this.posto_origin = json
        } else if (cnpj === this.transferenciaData.cnpj_destino) {
          console.log('posto destino')
          this.posto_destino = json
        }
      })
    },
    resetarComponente () {
      this.step = 1
      this.alerta.ativo = false
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.transferenciaData = {
        cnpj_origem: null,
        cnpj_destino: null,
        criar_destino_se_nao_existir: false
      }
    },
    ativarAlerta (texto, tipo = 'error') {
      this.alerta.texto = texto
      this.alerta.tipo = tipo
      this.alerta.ativo = true
      setTimeout(() => {
        this.alerta.ativo = false
      }, 6000)
    },
    prosseguirParaConfirmacao () {
      if (this.$refs.form.validate()) {
        this.step = 2
      }
    },
    async executarTransferencia () {
      try {
        const response = await this.$store.dispatch('transferirInformacoesDoPosto', this.transferenciaData)
        this.ativarAlerta(response.message || 'Operação concluída com sucesso!', 'success')
        this.fecharDialog()
        this.$emit('transferencia-concluida')
      } catch (error) {
        this.ativarAlerta(error.message || 'Ocorreu um erro na transferência.', 'error')
        this.step = 1
      }
    }
  }
}
</script>
